export const WarnLimitForLicMgt = 5;

// For Astar
export const AstarFortNoxArticleNumbers = ["IN9920SE", "IN9900SE"];
export const AstarCustomerGroupId = 5;
export const ExcludedLicensesForAstar = ["IN1100SE", "IN1000SE"];
export const InternalEmails = [
  "collinribbaa@gmail.com",
  "isacgunnarsson3@gmail.com",
];

// For result overview
export const FINAL_EXAM_TYPE = {
  PARENT: "parent",
  CHILD: "child",
};

// Manuals are placed in lwc/manuals on the server (not in the build), resolved against <base href> since test is served from another path
export const manualUrl = (fileName) =>
  new URL(`manuals/${fileName}`, document.baseURI).href;

export const LWC_MANUAL_PDF_PATH = manualUrl("manual_LWC.pdf");
export const APL_TEACHER_MANUAL_PDF_PATH = manualUrl("manual_APL_larare.pdf");
export const APL_STUDENT_MANUAL_PDF_PATH = manualUrl("manual_APL_elev.pdf");
export const APL_SUPERVISOR_MANUAL_PDF_PATH = manualUrl(
  "manual_APL_handledare.pdf",
);

// For Focus Control
export const FOCUS_CONTROL_MANUAL_PDF_PATH = manualUrl(
  "Manual_Fokuskontroll.pdf",
);
